import React from 'react';
import { OrdersProvider } from '@warehouse/quickbase';
import { OrdersQuickbase } from './Orders';

export function Orders() {
	return (
		<OrdersProvider>
			<OrdersQuickbase />
		</OrdersProvider>
	);
}
